// File: src/components/Maintenance/SkeletonTaskRow.jsx

import React from 'react';

const SkeletonTaskRow = () => {
  return (
    <tr className="animate-pulse border-t border-neutral-800">
      {[...Array(8)].map((_, idx) => (
        <td key={idx} className="p-3">
          <div className="h-4 bg-neutral-700 rounded w-full max-w-[90%]" />
        </td>
      ))}
    </tr>
  );
};

export default SkeletonTaskRow;
